/**
 * HEADER REDUX ACTIONS
 *
 * @version 0.1
 */

import reduxStore from './../../reduxStore';

export const UPDATE_HEADER = 'UPDATE_HEADER';
export const UPDATE_HELP_URL = 'UPDATE_HELP_URL';

const actions = {
    updateHeader: function (location){
        reduxStore.dispatch({
            type: UPDATE_HEADER,
            payload: location
        });
    },
    updateHeaderContent: function (message, helpUrl) {
        reduxStore.dispatch({
            type: UPDATE_HEADER,
            payload: {
                menuStateClass: 'custom',
                subMenuMessage: `Custom_Message`,
                helpUrl:        helpUrl ? helpUrl : 'home?lbu=US&locale=en_US&audience=all',
                values: { message: message }
            }
        });
    },
    updateHelpUrl: function (helpUrl){
        reduxStore.dispatch({
            type: UPDATE_HELP_URL,
            payload: helpUrl
        });
    }
};

export default actions;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Header/Header.actions.js